import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { Flex, Box, Button, Copy } from '@elparking/components'

const renderPostaCodeTownAndProvice = (order) => order.postalCode || order.town || order.province

const ShippingInfo = ({
    order,
    onChangeShippingInfo,
}) => (
    <Box dataTest='shipping-info-block' mb='20px'>
        <Flex mb='10px' justifyContent='space-between' w='100%' alingItem='center'>
            <Copy padding='0' color='gray80' transform='uppercase' fontSize='small' fontWeight='medium'>
                <FormattedMessage defaultMessage='Detalles del envío' />
            </Copy>
            {onChangeShippingInfo && <Button.unstyled dataTest='change-shipping-info-button' padding='0' margin='0' fontSize='xSmall' onClick={onChangeShippingInfo}>
                <FormattedMessage defaultMessage='Cambiar' />
            </Button.unstyled>}
        </Flex>
        <Copy wordBreak='break-word' padding='0 0 8px 0' fontSize='small' fontWeight='regular'>
            { order.firstName } { order.lastName }
        </Copy>
        <Copy wordBreak='break-word' padding='0 0 8px 0' fontSize='small' fontWeight='regular'>
            { order.address }
        </Copy>
        { renderPostaCodeTownAndProvice(order) &&
            <Copy wordBreak='break-word' padding='0 0 8px 0' fontSize='small' fontWeight='regular'>
                { order.postalCode } { order.town } {order.province && `(${order.province.name})`}
            </Copy>
        }
        <Copy wordBreak='break-word' padding='0' fontSize='small' fontWeight='regular'>
            { order.email } { '|' } { order.phone }
        </Copy>
    </Box>
)

ShippingInfo.propTypes = {
    order: PropTypes.shape({
        firstName: PropTypes.string.isRequired,
        lastName: PropTypes.string.isRequired,
        address: PropTypes.string,
        postalCode: PropTypes.string,
        town: PropTypes.string,
        province: PropTypes.shape({
            name: PropTypes.string.isRequired,
        }),
        phone: PropTypes.string,
        email: PropTypes.string.isRequired,
    }),
    onChangeShippingInfo: PropTypes.func,
}

export default ShippingInfo
